// Define Error Prefix
const PASSWORD_PREFIX = 1000;

// Define Error Codes
const MISSING_PASSWORD = PASSWORD_PREFIX + 1;
const SHORT_PASSWORD = PASSWORD_PREFIX + 2;
const MISSING_NUMBER = PASSWORD_PREFIX + 3;
const MISSING_LETTER = PASSWORD_PREFIX + 4;

// Public Error Codes
export const PASSWORD_ERRORS = {
  MISSING_PASSWORD,
  SHORT_PASSWORD,
  MISSING_NUMBER,
  MISSING_LETTER,
};

// Corresponding Error Messages
export const PASSWORD_ERROR_MESSAGES = {
  [MISSING_PASSWORD]: "Password Required.",
  [SHORT_PASSWORD]: "At least 8 characters are required.",
  [MISSING_NUMBER]: "You must include at least 1 number.",
  [MISSING_LETTER]: "You must include at least 1 letter.",
};

const MIN_LENGTH = 8;

export default class PasswordValidator {
  static validatePassword(password) {
    let errors = [];

    // Password Length
    if (!password || !(password.length >= MIN_LENGTH)) {
      errors.push(SHORT_PASSWORD);
    }

    // Contains digits
    if (!/\d/.test(password)) {
      errors.push(MISSING_NUMBER);
    }

    // Contains letter
    if (!/[A-Za-z]+/.test(password)) {
      errors.push(MISSING_LETTER);
    }

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static constructErrorMessage(errors) {
    const message = [];

    errors.forEach((error) => {
      message.push(PASSWORD_ERROR_MESSAGES[error]);
    });

    return message.join(" ");
  }

  static getErrorMessage(error) {
    return PASSWORD_ERROR_MESSAGES[error];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/validation/password.js